import type { WorkProductIndexOmissionSummary, WorkProductWarning } from "../../../shared/types";

export const AGENT_ARTIFACT_OMISSION_WARNING: WorkProductWarning = "agent_artifacts_omitted_from_brand_index";

export function visibleWorkProductWarnings(
  warnings: WorkProductWarning[],
  omissions: WorkProductIndexOmissionSummary[],
): WorkProductWarning[] {
  if (omissions.length === 0) {
    return warnings;
  }

  return warnings.filter((warning) => warning !== AGENT_ARTIFACT_OMISSION_WARNING);
}
